module.exports = __webpack_public_path__ + "src/assets/models/molar/spoon_1_w_salt.fbx";